import { FunctionComponent, useMemo } from 'react';
import { isMobileOnly } from 'react-device-detect';
import Skeleton from 'react-loading-skeleton';
import { getCssVar, isOrgLayout } from '../../utils';

import classes from './LayoutLoader.module.scss';

export const LayoutLoader: FunctionComponent = () => {
  const row = useMemo(() => {
    if (!isOrgLayout()) {
      return (
        <>
          <Skeleton width={getCssVar('--left-sidebar-width')} height={'calc(100vh - 7rem)'} />
          <Skeleton width={getCssVar('--content-max-width')} height={'calc(100vh - 7rem)'} />
          <Skeleton width={'18.75rem'} height={'calc(100vh - 7rem)'} />
        </>
      );
    }

    return (
      <>
        <Skeleton width={getCssVar('--left-sidebar-width')} height={'calc(100vh - 7rem)'} />
        <Skeleton width={getCssVar('--content-full-max-width')} height={'calc(100vh - 7rem)'} />
      </>
    );
  }, []);

  if (isMobileOnly) {
    return (
      <div className={classes['loader--mobile']}>
        <Skeleton height={'4rem'} />
        <Skeleton height={'4rem'} />
        <Skeleton height={'4rem'} />
      </div>
    );
  }

  return (
    <div className={classes['loader']}>
      <Skeleton height={getCssVar('--navbar-height')} />

      <div className={classes['loader__row']}>{row}</div>
    </div>
  );
};
